module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"addPhone":"Add a phone","addEmail":"Add an email","addFax":"Add a fax"}}')
  delete Component.options._Ctor
}
